import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent } from '@sirius/common';

import { IClosestAlternative } from '../../domain/alternatives';
import { ratedPayloadKg } from '../../domain/eligibility';
import { IStatusTemplates, IRequirementFigures, fillTemplate, measures, statusLineFor } from '../../domain/status-template';
import { IRobotOption } from '../../models/robot-selector.model';
import { CobotCardComponent } from '../cobot-card/cobot-card.component';

@Component({
    selector: 'robot-selector-alternatives-panel',
    templateUrl: './alternatives-panel.component.html',
    styleUrl: './alternatives-panel.component.scss',
    imports: [ButtonComponent, CobotCardComponent],
    host: {
        'class': 'robot-alternatives',
    },
})
export class AlternativesPanelComponent {
    readonly alternatives = input.required<readonly IClosestAlternative[]>();
    readonly viewProductLabel = input.required<string>();
    readonly relaxRequirementLabel = input.required<string>();
    readonly statusTemplates = input.required<IStatusTemplates>();
    readonly requirement = input.required<IRequirementFigures>();

    readonly alternativeSelected = output<IRobotOption>();

    readonly displayedAlternatives = computed(() =>
        this.alternatives().map((alternative) => ({
            alternative,
            statusLine: statusLineFor(alternative, this.requirement(), this.statusTemplates()),
            relaxRequirementLabel: fillTemplate(
                this.relaxRequirementLabel(),
                measures(
                    { payloadKg: ratedPayloadKg(alternative.robot), reachMm: alternative.robot.reachMm },
                    this.statusTemplates().locale,
                ),
            ),
        }))
    );
}
